import loadable from '@loadable/component';

export const GardeningKnowHowSiteWrapper = loadable(
  () => import(/* webpackChunkName: "gardeningknowhow-site" */ './GardeningKnowHowSiteWrapper'),
);
